import Table from '../reusable_components/Table';
import { url } from '../utils/config';
import { title } from '../utils/style';
import { FiBell, FiEye, FiTrash2 } from 'react-icons/fi';
import Modal from '../reusable_components/Modal';
import { useState } from 'react';
import ImageSlider from '../reusable_components/imageSlider.jsx';
import axios from 'axios';
import { setLoader } from "../reusable_components/Loader.js";
import { toast } from 'react-toastify';

function FinanceAppointments() {
    const [showModal, setShowModal] = useState(false);
    const [images, setImages] = useState([]);
    const [reloadTable, setReloadTable] = useState(false)

    const handleEyeClick = (data) => {
        setImages(data.pilot_estimate?.images || []);
        setShowModal(true);
    };


    async function handleResendEstimate(workOrder) {
        try {
            setLoader(true);
            const reqUrl = url + `/estimate_reminder`;
            const token = window.localStorage.getItem('token');
            const headers = { authorization: `bearer ${token}` };
            const { data: response } = await axios.post(reqUrl, { signwellId: workOrder.signwell_id }, { headers });
            toast.success(response.message, { autoClose: 3000 })
        } catch (e) {
            toast.error("Something went wrong", { autoClose: 3000 })
        } finally {
            setLoader(false);
        }
    }

    async function cancelBooking(booking) {
        try {
            setLoader(true);
            const reqUrl = url + `/cancel_booking/${booking.id}`;
            const token = window.localStorage.getItem('token');
            const headers = { authorization: `bearer ${token}` };
            const { data: response } = await axios.delete(reqUrl, { headers });
            toast.success(response.message, { autoClose: 3000 })
            setShowModal(false)
            setReloadTable((prev) => !prev);
        } catch (e) {
            toast.error("Something went wrong", { autoClose: 3000 })
        } finally {
            setLoader(false);
        }
    }

    const options = [
        {
            header: 'Booking Id',
            key: 'id',
            width: "5%",
            render: (data) => { return `AP0000${data.id}` }
        },
        {
            header: 'DATE',
            key: 'date',
            width: "5%",
            placeHolder: 'mm-dd-yyyy',
        },
        {
            header: 'TIME',
            key: 'time',
            width: "10%",
        },
        {
            header: 'Problem Description',
            key: 'problemDescription',
            width: "10%",
        },
        {
            header: 'VEHICLE INFO',
            width: "10%",
            render: (data) => { if (data['make']) return `${data['make']} - ${data['model']} - ${data['year']}` },
        },
        {
            header: 'ASSIGNED TO',
            width: "10%",
            render: (data) => {
                if (data['technician']['firstName']) return `${data['technician']['firstName'] + " " + data['technician']['lastName'] || ''}`
            },
        },
        {
            header: 'Booking Status',
            key: 'status',
            width: "5%",
            render: (data) => {
                let colorClass = "";

                switch (data.status) {
                    case "Pending":
                        colorClass = "text-yellow-500 font-semibold";
                        break;
                    case "Cancelled":
                        colorClass = "text-red-500 font-semibold";
                        break;
                    case "Closed":
                        colorClass = "text-green-500 font-semibold";
                        break;
                    default:
                        colorClass = "text-blue-500 font-semibold";
                        break;
                }

                return <span className={colorClass}>{data.status}</span>;
            },
        },
        {
            header: 'Estimate Status',
            key: 'pilot_status',
            width: "5%",
            render: (data) => {
                let colorClass = "";

                switch (data.pilot_estimate?.status) {
                    case "Pending":
                        colorClass = "text-yellow-500 font-semibold";
                        break;
                    case "Rejected":
                        colorClass = "text-red-500 font-semibold";
                        break;
                    case "Approved":
                        colorClass = "text-green-500 font-semibold";
                        break;
                    default:
                        colorClass = "text-blue-500 font-semibold";
                        break;
                }

                return <span className={colorClass}>{data.pilot_estimate?.status || "Modified"}</span>;
            },
        },
        {
            header: "Expiry Date",
            key: "estimatedExpirationDate",
            width: "10%",
            render: (data) => {
                if (!data.pilot_estimate?.estimatedExpirationDate) {
                    return ""
                }
                const date = new Date(data.pilot_estimate.estimatedExpirationDate);
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                const year = date.getFullYear();
                return `${month}-${day}-${year}`;
            },
        },
        {
            header: 'Resend Estimate',
            width: "10%",
            render: (data) => {
                const disable = (data.status === "Cancelled" || data.status === "Closed" || data.pilot_estimate?.status !== "Pending") ? true : false
                const bgColor = disable ? "bg-green-300" : "bg-green-500";
                return <button
                    className={`flex text-xs items-center gap-1 rounded-full ${bgColor} text-white p-2 transition-all shadow-sm`}
                    onClick={() => handleResendEstimate(data.pilot_estimate)} disabled={disable}>
                    <FiBell className="text-sm" />
                    Resend
                </button>
            }
        },
        {
            header: 'Cancel Booking',
            width: "10%",
            render: (data) => {
                const disable = (data.status === "Cancelled" || data.status === "Closed" || data.pilot_estimate?.status === "Approved") ? true : false
                const bgColor = disable ? "bg-red-300" : "bg-red-500";
                return <button
                    className={`flex text-xs items-center gap-1 rounded-full ${bgColor} text-white p-2 transition-all shadow-sm`}
                    onClick={() => cancelBooking(data)}>
                    <FiTrash2 className="text-sm" />
                    Cancel
                </button>
            }
        },
        {
            header: 'Images',
            width: "10%",
            render: (data) =>
                <FiEye className='text-blue-600 cursor-pointer ml-3' onClick={() => handleEyeClick(data)} />
        },
    ]

    const excludeFilter = ['VEHICLE INFO', 'Estimate Status', 'Images', 'Cancel Booking', 'Resend Estimate', 'Expiry Date']

    return (
        <div className="p-4">
            <div className={`${title} mb-4`}>Appointments</div>
            <Table
                url={url + '/appointments'}
                options={options}
                pagination
                noButton
                reloadTable={reloadTable}
                excludeFilter={excludeFilter}
            />
            {showModal && (
                <Modal setShowModal={setShowModal} component={() => (
                    <ImageSlider
                        images={images}
                        imageUrlInfix="estimate_images"
                    />
                )} />
            )}
        </div>
    )
}

export default FinanceAppointments;